import FlowioFileDropzone from "./FlowioFileDropzone";

export default FlowioFileDropzone;
export type { FlowioFileDropzoneProps } from "./FlowioFileDropzone";
